import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { RepositoryModal, SafetyMitigation } from '../../shared'

@Component({
    templateUrl: './safety-mitigation.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class SafetyMitigationComponent extends RepositoryModal<SafetyMitigation> implements OnInit {
    ngOnInit() {
        this.target.y = 0
    }
}
